import { useEffect, useState } from "react";
import { Card, Label } from "@osago/ui";
import { useDebouncedValue } from "@/shared/lib/useDebouncedValue";
import { useReferral } from "../model/referralContext";
import { useReferralLink } from "../model/useReferralLink";
import { withPreviewFlag } from "@/shared/lib/referralLink";

export function ReferralPreview() {
  const { url, isReady } = useReferralLink();
  const { companiesCleared } = useReferral();
  const [loaded, setLoaded] = useState(false);
  const previewUrl = useDebouncedValue(isReady ? url : "", 700);
  // В iframe добавляем preview=true: сайт по этому признаку не подтягивает
  // последний черновик. В саму ссылку партнёра параметр не попадает.
  const frameUrl = previewUrl ? withPreviewFlag(previewUrl) : "";

  useEffect(() => {
    setLoaded(false);
  }, [previewUrl]);

  return (
    <Card padding="none" className="flex flex-col overflow-hidden">
      <div className="flex items-center gap-2 border-b border-input-border px-4 py-2.5">
        <span
          className={`h-2.5 w-2.5 rounded-full transition-colors duration-300 ${
            loaded && previewUrl ? "preview-dot-on" : "bg-input-border"
          }`}
        />
        <Label variant="caption">Предпросмотр перехода по ссылке</Label>
      </div>
      {previewUrl ? (
        <iframe
          key={previewUrl}
          src={frameUrl}
          title="Предпросмотр перехода по реферальной ссылке"
          className="h-160 w-full border-0"
          sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox"
          onLoad={() => setLoaded(true)}
        />
      ) : (
        <div className="flex min-h-80 items-center justify-center p-8 text-center">
          <Label variant="body" className="max-w-xs">
            {companiesCleared
              ? "Выберите страховые компании слева — и здесь появится страница, которую увидит клиент по вашей ссылке"
              : "Укажите партнёрский ID слева — и здесь появится страница, которую увидит клиент по вашей ссылке"}
          </Label>
        </div>
      )}
    </Card>
  );
}
